export class SurveyModel {
  IntakeId: number
  ProviderRating: number
  ExperienceRating: number
  SurveyType: string
  Comment: string
  AllowedtoShare: boolean
}